import { useNavigate } from "react-router-dom";
import { PROFILE_HOUSEHOLD_DATA_VIEW_PATH } from "../../../../constants/env";
import { ConfirmExitContent } from "../../../../legacy/pages/ProfileData/modals/confirm-exit-content/confirm-exit-content";

export function ConfirmExitMaritalStatusModal(): JSX.Element {
  const navigate = useNavigate();

  function handleExit() {
    navigate(PROFILE_HOUSEHOLD_DATA_VIEW_PATH, { replace: true });
  }

  return <ConfirmExitContent onExit={handleExit} />;
}
